/* Shared vocabulary. No DOM, no React, no globals — every engine module here
   takes the plan document as an argument so the same code runs in a worker,
   in a test, or on the server if it ever needs to. */

import { blankLighting } from './lightingData.js';

export const DEG = 180 / Math.PI;
export const RAD = Math.PI / 180;
export const WALL_THICKNESS = 0.12;
export const WALL_MOUNT_OFFSET = 0.22;

export const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
export const uid = p => p + Math.random().toString(36).slice(2, 9);
export const fmt = (v, d = 1) => (Math.round(v * 10 ** d) / 10 ** d).toFixed(d);
export const norm360 = a => ((a % 360) + 360) % 360;
export const angDiff = (a, b) => { const d = norm360(a - b); return d > 180 ? 360 - d : d; };

export const LEVELS = [
  { k: 'none',      label: 'Blind' },
  { k: 'detect',    label: 'Detect' },
  { k: 'observe',   label: 'Observe' },
  { k: 'recognise', label: 'Recognise' },
  { k: 'identify',  label: 'Identify' }
];

export const REQS = [
  { k: 'detect',    label: 'Detect — someone is there',              lvl: 1 },
  { k: 'observe',   label: 'Observe — what they are doing',          lvl: 2 },
  { k: 'recognise', label: 'Recognise — someone you already know',   lvl: 3 },
  { k: 'identify',  label: 'Identify — legacy face detail target', lvl: 4 },
  { k: 'plate',     label: 'Read a licence plate',                   lvl: 5 },
  ...[['overview', 'Overview', 0.8], ['outline', 'Outline', 1.5], ['discern', 'Discern', 2.5], ['perceive', 'Perceive', 3], ['characterize', 'Characterize', 4], ['validate', 'Validate', 6], ['scrutinize', 'Scrutinize', 7]].map(([k, label, lvl]) => ({ k, label: label + ' · 2025', lvl }))
];

export const requirementIntent = r => ({ detect: 'Detect presence · Detect', observe: 'Understand activity · Observe', recognise: 'Recognise a familiar person · Recognise', identify: 'Capture face detail · Identify', plate: 'Capture licence plate detail' })[r.k] || r.label;

export const reqByKey = k => REQS.find(r => r.k === k) || REQS[2];

export function blankDoc() {
  return {
    v: 6,
    walls: [], areas: [], zones: [], cams: [], models: [],
    equipment: [], cables: [], accessories: [], viewpoints: [], targets: [], lights: [], lighting: blankLighting(),
    measurementChecks: [], fieldReferences: [], wallLengthLocks: [], openings: [], tasks: [], obstacles: [], dismissedEntries: [], floors: [], stairs: [], activeFloorId: 'ground', sceneState: 'design',
    install: { slackPct: 10, cableCost: 0, maxRun: 90 },
    planning: {}, review: null, setup: { scaleConfirmed: false },
    bg: null,
    opt: {
      measurementSystem: 'metric',
      scale: 30, grid: 1, snap: true, ortho: true, showGrid: true,
      step: 0.5, general: 3, currency: '$', profile: 'dori-2015', faceYaw: 45,
      t: { detect: 25, observe: 62.5, recognise: 125, identify: 250, plate: 200 },
      hFace: 1.6, hPlate: 0.5, aFace: 30, aPlateT: 30, aPlateI: 30
    }
  };
}

export const modelById = (S, id) => S.models.find(m => m.id === id) || null;
